import { h } from "preact";

import SecondaryNaviItem from "./SecondaryNaviItem.jsx";

export default function SecondaryNavi({ children, items }) {
  return (
    <div class="secondary-navi__wrapper">
      <div class="secondary-navi" role="menu">
        {(items || []).map((item) => (
          <SecondaryNaviItem key={item.link} {...item} />
        ))}
      </div>
      {children && <div>{children}</div>}
    </div>
  );
}
